import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "duo",
  "use": "duo-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"duo\">\n  <path d=\"M5 18.3333L1 22.3333L1 1H22.3333L18.3333 5H5V18.3333Z\" fill=\"#727272\" />\n  <path d=\"M19 5.66667L23 1.66667L23 23L1.66667 23L5.66667 19L19 19L19 5.66667Z\" />\n  <path d=\"M8.33333 8.33333H15.6667V15.6667H8.33333V8.33333Z\" fill=\"#727272\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol